import * as React from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import QrCode2Icon from "@mui/icons-material/QrCode2";
import {Button, DialogContent, Grid, IconButton, Slide, Snackbar, Typography} from "@mui/material";
import QRCode from "react-qr-code";
import {useEffect, useState} from "react";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function SimpleDialog(props) {
    const { onClose, selectedValue, open, event } = props;
    const [publicLink, setPublicLink] = useState('')
    const [controlLink, setControlLink] = useState('')
    const [snackOpen, setSnackOpen] = useState(false)


    useEffect(()=>{
        setPublicLink('https://vote.2ndstage.app/vote/'+event.id)
        setControlLink('https://control.2ndstage.app/control/'+event.id)
    }, [])

    const handleClose = () => {
        onClose(selectedValue);
    };

    const Qr = ({url, title, })=> (
        <Grid item xs={6}>
            <Typography variant={'h4'}>{title}</Typography>
            <QRCode value={url} bgColor={'transparent'} fgColor={'#eceff1'}/> {/*TODO inserire i link ufficiali*/}
            <Button onClick={()=>copyLink(url)}>Copy Link</Button>
        </Grid>
    )

    const copyLink = (url) => {

        navigator.clipboard.writeText(url).then(r => setSnackOpen(true))
    }

    return (
        <Dialog onClose={handleClose} open={open} TransitionComponent={Transition}>
            <DialogTitle>Event Qr</DialogTitle>
            <DialogContent>
                <Grid container spacing={5}>
                    <Qr url={publicLink} title={'Public'}/>
                    <Qr url={controlLink} title={'Control'}/>
                </Grid>
            </DialogContent>
            <Snackbar
                open={snackOpen}
                autoHideDuration={2000}
                message={'Link copied!'}
                onClose={()=>setSnackOpen(false)}
            />
        </Dialog>
    )
}

SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

export default function QrButton({event}) {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (value) => {
        setOpen(false);
    };

    return (
        <div>
            <IconButton onClick={handleClickOpen} aria-label="delete" size={"large"}>
                <QrCode2Icon fontSize={"inherit"}/>
            </IconButton>
            <SimpleDialog
                event={event}
                open={open}
                onClose={handleClose}
            />
        </div>
    );
}
